import * as actionTypes from '../API/ActionTypes';
import initialState from "./initialState";

import * as AppUtils from "../Utils/AppUtils";
import appConstants from '../appConstants';

export function commonReducer (state = initialState.appInitialState, action)  
{
	let trigger = [];
	let open = [];

	switch (action.type) 
	{
		case actionTypes.COLLAPSE_MENU:
			return {
				...state,
				collapseMenu: !state.collapseMenu
			};
		case actionTypes.COLLAPSE_TOGGLE:
			if (action.menu.type === 'sub') 
			{
				open = state.isOpen;
				trigger = state.isTrigger;

				const triggerIndex = trigger.indexOf(action.menu.id);
				if (triggerIndex > -1) 
				{
					open = open.filter(item => item !== action.menu.id);
					trigger = trigger.filter(item => item !== action.menu.id);
				}

				if (triggerIndex === -1) 
				{
					open = [...open, action.menu.id];
					trigger = [...trigger, action.menu.id];
				}
			} else 
			{
				open = state.isOpen;
				const triggerIndex = (state.isTrigger).indexOf(action.menu.id);
				trigger = (triggerIndex === -1) ? [action.menu.id] : [];
				open = (triggerIndex === -1) ? [action.menu.id] : [];
			}

			return {
				...state,
				isOpen: open,
				isTrigger: trigger
			};
		case actionTypes.NAV_CONTENT_LEAVE:
			return {
				...state,
				isOpen: open,
				isTrigger: trigger,
			};
		case actionTypes.NAV_COLLAPSE_LEAVE:
			if (action.menu.type === 'sub') 
			{
				open = state.isOpen;
				trigger = state.isTrigger;

				const triggerIndex = trigger.indexOf(action.menu.id);
				if (triggerIndex > -1) 
				{
					open = open.filter(item => item !== action.menu.id);
					trigger = trigger.filter(item => item !== action.menu.id);
				}
				return {
					...state,
					isOpen: open,
					isTrigger: trigger,
				};
			}
			return {...state};
		case actionTypes.FULL_SCREEN :
			return {
				...state,
				isFullScreen: !state.isFullScreen
			};
		case actionTypes.FULL_SCREEN_EXIT:
			return {
				...state,
				isFullScreen: false
			};
		case actionTypes.CHANGE_LAYOUT:
			return {
				...state,
				layout: action.layout
			};
		default:
			return state;
	}
};

export function appCommonReducer (state = initialState.appCommonReducerVal, action)  
{
	switch (action.type) 
	{
		case actionTypes.SENSOR_STATE:
			return {
				...state,
				selectedSensorState: action.sensorState
			}
		case actionTypes.SELECTED_SENSOR:
			return {
				...state,
				selectedSensor: action.selectedSensor
			}
		case actionTypes.SUPER_ASSET:
			return {
				...state,
				selectedSuperAsset: action.superAsset
			};
		case actionTypes.SELECTED_CONDITION:
			return {
				...state,
				selectedCondition: action.selectedCondition
			}
		case actionTypes.CUSTOMER_ID:
			return {
				...state,
				customerId: action.customerId
			};
		case actionTypes.LAST_SELECTED_CUSTOMER_ID:
			return {
				...state,
				lastSelectedCustomerId: action.lastSelectedCustomerId 
			};
		case actionTypes.ASSET_GRAPH_TYPE:
			return {
				...state,
				assetGraphType: action.assetGraphType
			}
		case actionTypes.ASSET_GRAPH_PARAM:
			return {
				...state,
				assetGraphParamIdx: action.assetGraphParamIdx
			}
		case actionTypes.ASSET_LIST_SEARCH_INPUT:
			return {
				...state,
				assetSearchText: action.assetSearchText
			};
		case actionTypes.SENSOR_LIST_SEARCH_INPUT:
			return {
				...state,
				searchTextObj: action.searchTextObj
			}
		case actionTypes.STORE_SENSOR_UNRESPONSIVE_REASON_FILTER:
			return {
				...state,
				selectedSensorUnresponsiveReasonFilter: action.selectedSensorUnresponsiveReasonFilter
			};
		case actionTypes.CLEAR_SENSOR_UNRESPONSIVE_REASON_FILTER:
			return {
				...state,
				selectedSensorUnresponsiveReasonFilter: null,
			};
		case actionTypes.SHOW_DECOMMISSIONED_ASSETS:
			return {
				...state,
				showDecommissionedAssets: action.showDecommissionedAssets
			}
		case actionTypes.SUPER_ASSET_SEARCH_INPUT:
			return {
				...state,
				superAssetSearchText: action.superAssetSearchText
			}
		case actionTypes.SHOW_MORE_TICKETS_IN_ASSET_DETAILS:
			return {
				...state,
				showMoreTicketsInAssetDetails: action.showMoreTickets
			}
		case actionTypes.SHOW_MORE_TICKETS_IN_TICKET_DETAILS:
			return {
				...state,
				showMoreTicketsInTicketDetails: action.showMoreTickets
			}
		case actionTypes.ASSET_PLOTLY_VIEW_TYPE:
			return {
				...state,
				assetPlotlyViewType: action.assetPlotlyViewType
			}
		case actionTypes.ASSET_PLOTLY_CENTER_DATE_TIME:
			return {
				...state,
				assetPlotlyCenterDateTime: action.assetPlotlyCenterDateTime
			}
		case actionTypes.ASSET_PLOTLY_FREQUENCY_TYPE:
			return {
				...state,
				assetPlotlyFrequencyType: action.assetPlotlyFrequencyType
			}
		case actionTypes.ASSET_PLOTLY_METRIC_TYPE:
			return {
				...state,
				assetPlotlyMetricType: action.assetPlotlyMetricType
			}
		case actionTypes.ASSET_PLOTLY_GRAPH_PARAMS:
			return {
				...state,
				assetPlotlyGraphParams: action.params
			}
		case actionTypes.ASSET_PLOTLY_TABLE_PARAMS:
			return {
				...state,
				assetPlotlyTableParams: action.params
			}	
		case actionTypes.ASSET_DOWNLOAD_MEASUREMENT_START_DATE:
			return {
				...state,
				assetDownloadMeasurementStartDate: action.assetDownloadMeasurementStartDate
			}
		case actionTypes.ASSET_DOWNLOAD_MEASUREMENT_END_DATE:
			return {
				...state,
				assetDownloadMeasurementEndDate: action.assetDownloadMeasurementEndDate
			}
		case actionTypes.UPDATE_SCREEN_CONTEXT:
			var existingScreenContext = state.screenContext ? state.screenContext : [];
			var screenIdx = -1;
			if(action.screenAction == appConstants.ADD_SCREEN_CTXT_TO_SESSION)
			{
				existingScreenContext = [];
				existingScreenContext.push(action.screen);
			} else if(action.screenAction == appConstants.PUSH_SCREEN_CTXT_TO_SESSION)
			{
				screenIdx = AppUtils.getIdx(existingScreenContext, action.screen); //existingScreenContext.indexOf(action.screen);
				if(screenIdx > -1)
				{
					existingScreenContext.splice(screenIdx);
				}
				existingScreenContext[state.screenContext.length] = action.screen;
			} else if(action.screenAction == appConstants.POP_SCREEN_CTXT_FROM_SESSION)
			{
				screenIdx = existingScreenContext.indexOf(action.screen);
				if(screenIdx > -1)
				{
					existingScreenContext.splice(screenIdx, 1);
				}
			}
			return {
				...state,
				screenContext: existingScreenContext,
				screenMode: action.mode,
			}
		case actionTypes.SELECTED_FEED:
			return {
				...state,
				selectedFeed: action.feed
			};
		case actionTypes.USER_LIST_SEARCH_INPUT:
			return {
				...state,
				userSearchText: action.userSearchText
			};
		case actionTypes.TICKET_ID_AND_ASSET_ID:
			return {
				...state,
				ticketIdAndAssetId: action.ticketIdAndAssetId
			};
		case actionTypes.SELECTED_USER:
			return {
				...state,
				selectedUser: action.selectedUser
			};		
		case actionTypes.FEED_FILTER_BUTTON_STATE:
			return {
				...state,
				feedFilterButtonState: action.feedFilterButtonState
			};
		case actionTypes.INCLUDE_SUPER_ASSET_TO_LIST_BASED_ON_TREND_FLAG:
			return {
				...state,
				includeSuperAssetToListBasedOnTrendFlg: action.includeSuperAssetToListBasedOnTrendFlg
			};
		case actionTypes.SELECTED_FEEDBACK_FILTER:
			return {
				...state,
				selectedFeedbackFilter: action.selectedFeedbackFilter
			}
		case actionTypes.SELECTED_RUM:
			return {
				...state,
				selectedRum: action.selectedRum
			}
		default:
			return state;
	}
};